(()=>{'use strict';
const skip='script,style,noscript,textarea,input,select,option,svg,math,[contenteditable],.uf-registered-mark';
function fix(root){
 const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
 const nodes=[];while(walker.nextNode())if(walker.currentNode.data.includes('®'))nodes.push(walker.currentNode);
 nodes.forEach(node=>{
 if(!node.parentElement||node.parentElement.closest(skip))return;
 for(let i=node.data.length-1;i>=0;i--){
 if(node.data[i]!=='®')continue;
 let context=node.parentElement;
 for(let j=0;j<3&&context.parentElement&&context.textContent.trim()==='®';j++)context=context.parentElement;
 const range=document.createRange();range.selectNodeContents(context);range.setEnd(node,i);
 if(!/ultra\s*flex\s*$/i.test(range.toString()))continue;
 let wrapper=node.parentElement;
 if(wrapper.textContent.trim()==='®'){
 while(wrapper.parentElement&&wrapper.parentElement.textContent.trim()==='®')wrapper=wrapper.parentElement;
 wrapper.classList.add('uf-registered-mark');
 }else{
 const tail=node.splitText(i);tail.splitText(1);
 const mark=document.createElement('sup');mark.className='uf-registered-mark';
 tail.replaceWith(mark);mark.appendChild(tail);
 }
 }
 });
}
function start(){
 fix(document.body);
 const observer=new MutationObserver(records=>{
 observer.disconnect();
 const roots=new Set();
 records.forEach(r=>{if(r.type==='characterData')roots.add(r.target.parentElement);else r.addedNodes.forEach(n=>{if(n.nodeType===1)roots.add(n);else if(n.nodeType===3)roots.add(n.parentElement);});});
 roots.forEach(r=>{if(r&&r.isConnected)fix(r);});
 observer.observe(document.body,{childList:true,subtree:true,characterData:true});
 });
 observer.observe(document.body,{childList:true,subtree:true,characterData:true});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();